var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgActionrequired = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 40,
  height: 46,
  viewBox: "0 0 40 46",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M20 0L39.9186 11.5V34.5L20 46L0.0814152 34.5V11.5L20 0Z",
  fill: "#3F7F7D"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M19 24V18H21V24H19Z",
  fill: "white"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M20 28C19.3096 28 18.75 27.4404 18.75 26.75C18.75 26.0596 19.3096 25.5 20 25.5C20.6904 25.5 21.25 26.0596 21.25 26.75C21.25 27.4404 20.6904 28 20 28Z",
  fill: "white"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20 33C14.4772 33 10 28.5228 10 23C10 17.4772 14.4772 13 20 13C25.5228 13 30 17.4772 30 23C30 28.5228 25.5228 33 20 33ZM20 31C24.4183 31 28 27.4183 28 23C28 18.5817 24.4183 15 20 15C15.5817 15 12 18.5817 12 23C12 27.4183 15.5817 31 20 31Z",
  fill: "white"
})));
export { SvgActionrequired as ReactComponent };
export default __webpack_public_path__ + "assets/aaf0cec0.svg";